(function () {
  var notice = document.getElementById('partial-stock-notice');
  if (!notice) return;

  var inventory = parseInt(notice.dataset.inventory, 10);
  var qtyInput = document.querySelector('.quantity__input');

  function checkQty() {
    var qty = parseInt(qtyInput ? qtyInput.value : 1, 10);
    notice.style.display = qty > inventory ? 'block' : 'none';
  }

  if (qtyInput) {
    qtyInput.addEventListener('input', checkQty);
    qtyInput.addEventListener('change', checkQty);
  }

  checkQty();
})();
